import { SITE } from "@/data/site";
import { PageHero } from "@/components/Blocks";
import { useSeo } from "@/lib/seo";

function LegalPage({ title, intro, sections, testId }) {
  useSeo(title, intro);
  return (
    <>
      <PageHero testId={testId} eyebrow="Legal" title={title} intro={intro} />
      <section className="border-t border-si-line py-16 sm:py-24">
        <div className="wrap max-w-3xl">
          <p className="mb-12 rounded-xl border border-si-gold/30 bg-si-gold/5 p-4 text-sm text-si-gold" data-testid="legal-review-note">
            Draft for legal review: this page describes the site's actual data practices and should be reviewed against SparkIdea Interactive's legal entity and jurisdiction before launch.
          </p>
          <div className="space-y-10">
            {sections.map(([h, body]) => (
              <div key={h}>
                <h2 className="text-2xl font-bold tracking-tight">{h}</h2>
                <p className="mt-3 text-base leading-relaxed text-si-muted">{body}</p>
              </div>
            ))}
            <p className="text-base text-si-muted">Questions: <a className="text-si-cyan" href={`mailto:${SITE.email}`}>{SITE.email}</a></p>
          </div>
        </div>
      </section>
    </>
  );
}

export const Privacy = () => (
  <LegalPage testId="privacy-hero" title="Privacy Policy" intro="How SparkIdea Interactive collects and uses information submitted through this website."
    sections={[
      ["Information we collect", "When you use the contact form we collect your name, work email, company or product, the service you're interested in, your project description, and optional stage/budget and contact preferences. The venture partnership form collects founder name, work email, project name, idea, problem, target users, stage, team, partnership type, and optional links. We also record the page the form was submitted from and your consent."],
      ["How we use it", "We use submissions only to respond to your inquiry or evaluate your application. A copy of each submission is emailed to our team inbox so we can respond."],
      ["Storage and access", "Submissions are stored in our website database and are accessible only to authorized SparkIdea Interactive staff through a password-protected admin area."],
      ["Spam protection", "To prevent abuse, we temporarily record request metadata such as IP address for rate limiting; these records expire automatically."],
      ["Analytics", "This website may use privacy-conscious analytics to understand aggregate usage. We do not put the content of your form submissions into analytics events."],
      ["Your rights", "You can ask us to access, correct, or delete your submitted information by emailing us."],
    ]} />
);

export const Terms = () => (
  <LegalPage testId="terms-hero" title="Terms of Service" intro="Terms for using the SparkIdea Interactive website."
    sections={[
      ["Use of this website", "This website provides information about SparkIdea Interactive, its ventures, and its services. You agree not to misuse the site or its forms, including submitting spam or malicious content."],
      ["No offer or guarantee", "Content on this site is informational. It is not an offer of services, funding, or partnership. Any engagement or partnership is subject to a separate written agreement."],
      ["Venture products", "Nautis, DemoVexa, Qikod, and other ventures are independent products with their own websites and terms."],
      ["Intellectual property", "The SparkIdea Interactive name, logo, and site content belong to SparkIdea Interactive. Venture names and logos belong to their respective products."],
      ["Liability", "The website is provided as is. To the extent permitted by law, SparkIdea Interactive is not liable for losses arising from use of the site."],
    ]} />
);

export const Cookies = () => (
  <LegalPage testId="cookies-hero" title="Cookie Policy" intro="How this website uses cookies and similar technologies."
    sections={[
      ["Essential cookies", "Public visitors do not need cookies to browse the site or submit forms. Secure, HTTP-only session cookies are set only when an authorized administrator signs in to the admin area."],
      ["Analytics", "The site may load an analytics script that uses cookies or local storage to measure aggregate usage. You can block these in your browser settings without affecting the site's core functionality."],
      ["Managing cookies", "Most browsers let you view, block, and delete cookies. Blocking analytics cookies does not prevent you from contacting us."],
    ]} />
);
